import {Pipe, PipeTransform} from '@angular/core';
import {PlaceDTO, PlaceRank} from '@domain/place/place.dto';

@Pipe({
  name: 'placeRegion',
  pure: true
})
export class PlaceRegionPipe implements PipeTransform {

  transform(value: PlaceDTO | null): PlaceDTO | null {
    return PlaceRegionPipe.getRegion(value);
  }

  private static getRegion(place: PlaceDTO | null): PlaceDTO | null {
    if (!place) {
      return null;
    }
    let current: PlaceDTO | null = place;
    while (current) {
      if (current.rank === PlaceRank.Region) {
        return current;
      }
      current = current.parent ?? null;
    }
    return null;
  }

}
